<template>
  <div class="change-password-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Zmień hasło</h1>
    </div>

    <div class="section-card position-relative">
      <HintComponent page-key="admin_panel_change_password" :absolute="true"/>
      <div class="section-card-header">
        <h2>Aktualizacja hasła</h2>
        <p class="section-subtitle">Po zmianie hasła nastąpi wylogowanie i ponowne logowanie.</p>
      </div>

      <form @submit.prevent="changePass" class="password-form">
        <div class="form-group">
          <label for="oldpassword">Stare hasło</label>
          <input type="password" name="oldpassword" id="oldpassword" placeholder="Stare hasło" v-model="passData.oldpassword" required>
        </div>

        <div class="form-group">
          <label for="newpassword">Nowe hasło</label>
          <input type="password" name="newpassword" id="newpassword" placeholder="Nowe hasło" v-model="passData.newpassword" required minlength="8">
        </div>

        <div class="form-group">
          <label for="repeatpassword">Powtórz hasło</label>
          <input type="password" name="repeatpassword" id="repeatpassword" placeholder="Powtórz nowe hasło" v-model="passData.repeatpassword" required minlength="8">
        </div>

        <div class="form-actions">
          <button class="btn-primary" type="submit">Zmień hasło</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'ChangePassword',
  components: {HintComponent},
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      passData: {
        oldpassword: '',
        newpassword: '',
        repeatpassword: '',
      },
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
  },
  methods: {
    changePass() {
      axios.post('/ChangePassword', this.passData, authHeader()).then(res => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano hasło');
          window.location.href = '/';
        }
      }).catch(() => {
        this.appStore.setIsAlert('złe bieżące hasło');
      });
    },
  },
};
</script>

<style scoped lang="scss">
.change-password-admin {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.password-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 520px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.form-actions {
  display: flex;
  justify-content: flex-start;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

@media (max-width: 480px) {
  .change-password-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary {
    width: 100%;
    text-align: center;
  }

  .form-actions {
    justify-content: stretch;
  }
}
</style>